import { ReactElement, ReactNode } from 'react';
import { createRoot } from 'react-dom/client';

export class OverlayContent {
  globalContainer: HTMLElement = document.getElementById('canvas-wrapper')!;

  constructor() {}

  public openOverlay(content: ReactElement): () => void {
    const container = document.createElement('div');
    const root = createRoot(container);
    this.globalContainer.appendChild(container);

    const close = () => {
      root.render(null);
    };

    root.render(<Modal>{content}</Modal>);

    return close;
  }
}

const Modal = ({ children }: { children: ReactElement }): ReactNode => {
  return (
    <div className="game-overlay">
      <style>
        {`
            .game-overlay {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              height: 100%;
              display: flex;
            }
            .game-overlay-content {
              width: 100%;
              height: 100%;
            }
        `}
      </style>
      <div className="game-overlay-content">{children}</div>
    </div>
  );
};
